// AppWrapper.tsx
import React from 'react';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import AppRouter from './AppRouter';

export const AppWrapper: React.FC = () => {
  return (
    <SubscriptionProvider>
      <AppRouter />
    </SubscriptionProvider>
  );
};
